import { Box, Divider, Typography, useTheme, TextField } from "@mui/material";
import { tokens } from "../../theme";
import { useState, useEffect } from "react";
import styles from './card-precos.module.css'
import SemProduto from "../../assets/img/produto-sem-imagem.jpg"


import { useMemo } from "react";

const CardPrecos = ({ data, index, gridLayout, onValueChange, newValue }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [hasError, setHasError] = useState(false);
    const [isHovered, setIsHovered] = useState(false);


    const handleDataHere = (data, event) => {
        let value = event.target.value;

        // Remove any character that is not a number, dot, or comma
        value = value.replace(/[^0-9.,]/g, "");

        // Replace all dots with commas
        value = value.replace(/\./g, ",");

        // Ensure only one comma is present and keep the first occurrence
        const parts = value.split(",");
        if (parts.length > 2) {
            value = parts[0] + "," + parts.slice(1).join(""); // Keep only the first comma
        }

        // Notify parent component
        onValueChange(data, value);
    };






    const handleImageError = (event) => {
        event.target.src = SemProduto; // Fallback to placeholder
    };

    const closeImage = () => {
        setIsHovered(false);
    };

    // Close image on key press
    useEffect(() => {
        const handleKeyPress = () => {
            closeImage();
        };

        window.addEventListener("keydown", handleKeyPress);
        return () => {
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, []);

    const handleHover = () => {
        if (!hasError) {
            setIsHovered(prev => !prev);
        }
    };

    const formatNumber = (number) => {
        if (!number) return "-";
        return number?.toLocaleString("pt-br", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    const formatWord = (word) => {
        if (!word) return "";
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    };

    const formattedValues = useMemo(() => ({
        model: formatWord(data?.model),
        weight: formatNumber(data?.weight),
        plated: formatNumber(data?.plated),
        rodio_b: formatNumber(data?.rodio_b),
        rodio_n: formatNumber(data?.rodio_n),
        costPrice: formatNumber(data?.cost_price),
        chargedPrice: formatNumber(data?.charged_price),
        cost_un: formatNumber(data?.cost_price - data?.plated),
        sugestedPrice: formatNumber(data?.sugestedPrice)
    }), [data]);

    return (
        <>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: gridLayout,
                    gap: "10px",
                    alignItems: "center",
                    padding: "10px",
                    paddingLeft: "20px",
                    backgroundColor: index % 2 === 0 ? colors.pink[400] : colors.pink[500],
                    border: "2px solid transparent", // Default border
                    transition: "border-color 0.1s ease",
                    "&:focus-within": {
                        borderColor: colors.blueAccent[100], // Change border color when input is focused
                    },
                }}
            >
                <Typography sx={{ marginLeft: "-10px" }} variant="h5">
                    {index + 1}
                </Typography>
                <div className={styles.container} onClick={handleHover}>
                    <Box
                        component="img"
                        src={data?.imageUrl || SemProduto}
                        alt={data?.id_produto}
                        className={styles.smallImage}
                        onError={handleImageError}
                        loading="lazy"
                    />

                    {isHovered && (
                        <div className={styles.backdrop}>
                            <Box className={styles.imageContainer} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <Box
                                    component="img"
                                    src={data?.imageUrl || SemProduto}
                                    alt={data?.id_produto}
                                    className={styles.largeImage}
                                />
                                <Typography variant="subtitle1" className={styles.imageTitle} sx={{ marginTop: "8px" }}>
                                    {data?.id_produto || "No Title"}
                                </Typography>
                            </Box>
                        </div>
                    )}
                </div>

                <Typography variant="h5">{data.id_produto}</Typography>
                <Typography variant="h5">{data.color__color}</Typography>
                <Typography variant="h5">{formattedValues.model}</Typography>
                <Typography variant="h5">{data.initial_inventory}</Typography>
                <Typography variant="h5">{data.quantity_available}</Typography>
                <Typography variant="h5">{data.quantity_sellers}</Typography>
                <Typography variant="h5">R$ {formattedValues.cost_un}</Typography>
                <Typography variant="h5">{formattedValues.weight}</Typography>
                <Typography variant="h5">{formattedValues.plated}</Typography>
                <Typography variant="h5">{formattedValues.rodio_b}</Typography>
                <Typography variant="h5">{formattedValues.rodio_n}</Typography>
                <Typography variant="h5">R$ {formattedValues.costPrice}</Typography>
                <Typography variant="h5">R$ {formattedValues.chargedPrice}</Typography>
                <Typography variant="h5">R$ {formattedValues.sugestedPrice}</Typography>

                <TextField
                    key={`${data.model}-${data.pk}-${data.id_produto}`} // Ensure unique key
                    name={"newValue"}
                    label={"Preço Novo"}
                    variant="outlined"
                    value={newValue}
                    onChange={(e) => handleDataHere(data, e)}
                    sx={{
                        width: "120px",
                        "& .MuiOutlinedInput-root": {
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "white",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "white",
                            },
                            "&.Mui-focused": {
                                backgroundColor: "rgba(256,256,243,0.2)", // Change to your desired background color
                            },
                        },
                        "& .MuiInputLabel-root": {
                            color: "white",
                            opacity: 0.7,
                            "&.Mui-focused": {
                                color: "white",
                            }
                        },
                        "& .MuiInputBase-input": {
                            fontWeight: "bold", // Makes the entered value bold
                            color: "white", // Ensures input text remains white
                        },
                        "& .MuiInputBase-input::placeholder": {
                            fontWeight: "normal", // Keeps the placeholder normal
                            color: 'grey',
                            opacity: 0.7, // Optional: Adjusts placeholder opacity for better differentiation
                        }
                    }}
                    inputProps={{
                        inputMode: "decimal",
                        pattern: "[0-9]+([,][0-9]*)?",
                    }}
                />
            </Box>
            <Divider />
        </>
    );
};

export default CardPrecos;